/** Checks at compile-time that [name] is a key of [TObj] */
export const propertyOf = <TObj extends object>(name: keyof TObj) => name;

/** Returns a function that checks at compile-time that [name] is a key of [TObj]
 * E.g. `const ofMyClass = propertiesOf<MyClass>(); ofMyClass("foo"); ` */
export const propertiesOf =
  <TObj extends object>(_obj: TObj | undefined = undefined) =>
  <T extends keyof TObj>(name: T): T =>
    name;
